module.exports = __webpack_public_path__ + "static/media/gtl-bg-blue-blur.4de590e2.jpg";